const MapMarker = (props) => {
    return (
        <i className="fa fa-map-marker f25" style={{ cursor: "pointer" }}></i>
    );
}
export default MapMarker